<template>
  <!-- 企业监控 -->
  <div class="listvideo">
    <div v-for="(item, index) in videoList" :key="index">
      <video
        :id="'myVideo' + item.id"
        width="300"
        height="229"
        controls
        class="video-js vjs-default-skin vjs-big-play-centered"
        style="object-fit: fill"
      >
        <source :src="item.videoUrl" type="application/x-mpegURL" />
      </video>
      <p class="titleP">{{ item.videoName }}</p>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  props: ["videoList"],
  data() {
    return {
      // 企业监控
      element: 0,
      plays: [],
    };
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    initVideo() {
      this.element = this.videoList.length;
      for (let index = 0; index < this.element; index++) {
        let id = "myVideo" + this.videoList[index].id.toString();
        let that = this;
        setTimeout(function () {
          that.plays.push(videojs(id));
          videojs(id).ready(function () {
            let myPlayer = this;
            myPlayer.play();
          });
        }, 1000);
      }
    },
  },
  destroyed() {
    this.plays.filter((temp) => temp.dispose());
    this.videoId = "";
  },
};
</script>

<style ang="less" scoped>
.listvideo {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.titleP {
  height: 25px;
  font-size: 18px;
  text-align: center;
  color: #00ffce;
  margin-top: 14px;
  margin-bottom: 23px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/digital_industry/companyInformation/menu5.vue